const tabHasPermission = (permissions) => {
  const userPermissions = localStorage
    .getItem("permissions")
    .toLocaleLowerCase()
    .split(",");
  const checkPermissions = permissions.toLocaleLowerCase().split("|");
  let permissionGranted = false;
  for (let item of checkPermissions) {
    if (userPermissions.includes(item)) {
      permissionGranted = true;
      break;
    }
  }
  return permissionGranted;
};

export default tabHasPermission;
